/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type ESMStandard = (typeof ESMStandard)[keyof typeof ESMStandard];

export const ESMStandard = {
    Standard1851_2012: 1,
    Standard1851_2005: 2,
    Standard3666_2011: 3,
    Standard2993_2019: 4,
    BCA: 5,
} as const;
